import { Box, Button, Grid, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectPublico from "../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import SelectFazenda from "../../../../../../../components/SelectsSimpleApiQuery/SelectFazendas";
import SelectLojaComPesquisa from "../../../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa";
import { formatarInputValorMonetário } from "../../../../../../../helpers/masks";

export default function Step02() {

  const { watch, getValues, control, handleSubmit, setValue } = useFormContext()

  const handleNextStep = getValues('funcoesAux.onNext')
  const handleBackStep = getValues('funcoesAux.onBack')

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="step02.publico"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { error, invalid } }) => {
            return (
              <SelectPublico
                {...field}
                error={invalid}
                required
                errorMessage={error?.message}
                value={field.value}
                onChange={(valor) => {
                  field.onChange(valor)
                  setValue('step02.comprador', valor?.nome_pessoa.split(' ')[0])
                }}
              />
            )
          }}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="step02.fazenda"
          control={control}
          render={({ field }) => (
            <SelectFazenda
              {...field}
              value={field.value}
              codigo={watch("step02.publico")?.codigo_publico}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="step02.loja"
          control={control}
          render={({ field }) => (
            <SelectLojaComPesquisa
              {...field}
              value={field.value}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="step02.valor"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Valor"
              value={field.value}
              onChange={(e) => {
                const formattedValue = formatarInputValorMonetário(e.target.value)
                field.onChange(formattedValue);
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="step02.nr_documento"
          rules={{
            required: 'Campo obrigatório', min: {
              value: 1,
              message: 'O campo não pode ser zero'
            }
          }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              type="number"
              label="Número documento"
              value={field.value}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (inputValue.length <= 6) {
                  field.onChange(inputValue);
                }
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="step02.serie_documento"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              label="Série documento"
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              slotProps={{ htmlInput: { maxLength: 3 } }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 2 }}>
        <Controller
          name="step02.lote"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Lote"
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              slotProps={{ htmlInput: { maxLength: 4 } }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Controller
          name="step02.comprador"
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              fullWidth
              label="Comprador"
              slotProps={{ htmlInput: { maxLength: 4 } }}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Controller
          name="step02.historico"
          rules={{ required: 'Campo obrigatório' }}
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              {...field}
              required
              error={invalid}
              fullWidth
              label="Histórico"
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              helperText={invalid ? error?.message : ""}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Box display={'flex'} gap={2}>
          <Button
            variant="outlined"
            onClick={handleBackStep}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit(handleNextStep)}
          >
            Avançar
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}
